import { z } from 'zod/v4';

/** HITypeResponse */
export const HITypeDTO = z.object({
  id: z.uuid(),
  label: z.string(),
  /** Name */
  name: z.string(),
  /** Description */
  description: z.string(),
  /** Template */
  template: z.string(),
  /** Exporter ID */
  exporter_id: z.uuid().optional(),
  exporter_name: z.string().optional(),
  tags: z.array(z.string()).optional(),
});
export type HIType = z.infer<typeof HITypeDTO>;

// HiTypeCreateDTO = Omit<HITypeDTO, 'id' | 'name'> & { name: string }
export const HiTypeCreateDTO = HITypeDTO.omit({ id: true, name: true }).extend({
  name: z.string(),
});
export type HiTypeCreate = z.infer<typeof HiTypeCreateDTO>;

// HiTypeUpdateDTO = Omit<HiTypeCreateDTO, 'name'> & { id: string }
export const HiTypeUpdateDTO = HiTypeCreateDTO.omit({ name: true }).extend({
  id: z.uuid(),
});
export type HiTypeUpdate = z.infer<typeof HiTypeUpdateDTO>;

/** HITypeStatus */
export const HITypeStatusDTO = z.object({
  /** Id @format uuid */
  id: z.uuid(),
  /** Name */
  name: z.string(),
});
export type HITypeStatus = z.infer<typeof HITypeStatusDTO>;